export function formatPhoneNumber(phoneNumber) {
    const digits = ("" + phoneNumber).replace(/\D/g, "");
    const m = digits.match(/^(\d{3})(\d{3})(\d{4})$/);
    return !m ? null : m[1] + "-" + m[2] + "-" + m[3];
}

export function maskPhoneNumber(input) {
    const pattern = "999-999-9999";
    if (typeof input === "undefined" || input === null) {
        return "";
    }

    let result = input;
    for (let i = 0; i < pattern.length && i < result.length; i++) {
        if (isNaN(parseInt(pattern[i], 10))) {
            if (result[i] !== pattern[i]) {
                result = result.slice(0, i).concat(pattern[i], result.slice(i));
            }
        } else {
            while (result.length > i && isNaN(parseInt(result[i], 10))) {
                result = result.slice(0, i).concat(result.slice(i + 1));
            }
        }
    }
    result = result.slice(0, pattern.length);

    return result;
}

export function capitalize(text) {
    if (typeof text !== "string") {
        return "";
    } else {
        return text.charAt(0).toUpperCase() + text.slice(1);
    }
}

export function maskDate(input) {
    if (typeof input === "undefined" || input === null) {
        return "";
    }

    const rawInput = String(input);

    // If the user typed slash separators, preserve segment intent while still enforcing limits.
    if (rawInput.includes("/")) {
        const sanitized = rawInput.replace(/[^0-9/]/g, "");
        const segments = sanitized.split("/");

        const month = (segments[0] || "").replace(/\D/g, "").slice(0, 2);
        const rawDay = (segments[1] || "").replace(/\D/g, "");
        const day = rawDay.slice(0, 2);
        let year = (segments[2] || "").replace(/\D/g, "");

        // If only one slash exists and day overflows, spill extras into year.
        if (segments.length < 3 && rawDay.length > 2) {
            year = rawDay.slice(2) + year;
        }

        year = year.slice(0, 4);

        const firstSlashTyped = sanitized.includes("/");
        const secondSlashTyped = segments.length > 2 || year.length > 0;

        if (!month) {
            return "";
        }

        let result = month;

        if (firstSlashTyped) {
            result += "/";
            result += day;
        }

        if (secondSlashTyped) {
            result += "/";
            result += year;
        }

        // Keep support for explicit 1/1/2026 style input by normalizing only this exact case.
        if (/^\d\/\d\/\d{4}$/.test(result)) {
            const [m, d, y] = result.split("/");
            return `0${m}/0${d}/${y}`;
        }

        return result;
    }

    // No separators typed yet: progressively format plain digits as MM/DD/YYYY.
    const digits = rawInput.replace(/\D/g, "").slice(0, 8);

    if (digits.length <= 2) {
        return digits;
    }

    if (digits.length <= 4) {
        return digits.slice(0, 2) + "/" + digits.slice(2);
    }

    return digits.slice(0, 2) + "/" + digits.slice(2, 4) + "/" + digits.slice(4);
}
